import {
  SimpleForm,
  TextInput,
  required,
  email,
  SelectInput,
} from 'react-admin';
import { RolesMap, UserRoles } from '../../../shared/types/User';

export const ChangeUserForm = () => (
  <SimpleForm>
    <TextInput
      source="username"
      fullWidth
      label="Имя пользователя"
      validate={[required('Обязательно для заполнения')]}
    />
    <TextInput
      source="firstName"
      fullWidth
      label="Имя"
      validate={[required('Обязательно для заполнения')]}
    />
    <TextInput
      source="lastName"
      fullWidth
      label="Фамилия"
      validate={[required('Обязательно для заполнения')]}
    />
    <TextInput
      source="email"
      fullWidth
      label="E-mail"
      validate={[
        required('Обязательно для заполнения'),
        email('Укажите корректный E-mail'),
      ]}
    />
    <TextInput
      source="phone"
      fullWidth
      label="Телефон"
      validate={[required('Обязательно для заполнения')]}
    />
    <TextInput
      source="password"
      type="password"
      fullWidth
      label="Пароль"
      validate={[required('Обязательно для заполнения')]}
    />
    <SelectInput
      source="role"
      choices={[
        { name: RolesMap[UserRoles.admin], id: UserRoles.admin },
        { name: RolesMap[UserRoles.manager], id: UserRoles.manager },
      ]}
      label="Роль"
      fullWidth
      validate={[required('Обязательно для заполнения')]}
    />
  </SimpleForm>
);
